module.exports = __webpack_public_path__ + "static/media/Rating Copy 4.002dae8b.svg";